

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { BrowserModule } from '@angular/platform-browser';
import { MatButtonModule } from '@angular/material/button';
import { WallartComponent } from 'ZalamoLibrary/src/lib/ui/products/products-front/components/WYSIWYG/wallart/wallart.component';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  providers: [],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatSelectModule,
    BrowserModule,
    CommonModule,
    MatButtonModule,
    MatIconModule,
  ],
  declarations: [WallartComponent],
})
export class WallartPreviewModule {}
